import { participant, server, workoutDetailsInterface } from "../../app/consts";
import axios from "axios";

axios.defaults.withCredentials = true;

///////////////////////////////////////////// NOT SECURED //////////////////////////////////////////////////////////////////////////////

export const GetSingleWorkout = async (id: string) => {
  const res = await axios.get(`${server}workouts/getSingle/${id}`);
  return res.data.data;
}

export const UpdateParticipants = async (workoutInfo: { id: string, participantInfo: participant }) => {
  const res = await axios.patch(`${server}workouts/updateParticipants/${workoutInfo.id}`, workoutInfo.participantInfo);
  return res.data;
}

export const RemoveParticipant = async (workoutInfo: { workoutId: number, participantUid: string }) => {
  const res = await axios.delete(`${server}workouts/removeParticipant/${workoutInfo.workoutId}/${workoutInfo.participantUid}`);
  return res.data;
}

export const selfRemoveParticipant = async (data: { workoutId: number, uId: string, personalId: string, phoneNum: string, start: boolean }) => {
  const res = await axios.post(`${server}workouts/selfRemoveParticipants/${data.workoutId}/${data.uId}`, { "personalId": data.personalId, "phoneNum": data.phoneNum, "start": data.start });
  return res.data;
}

export const getParticipantEmail = async (data: { workoutId: string, uId: string }) => {
  const res = await axios.get(`${server}workouts/getParticipantEmail/${data.workoutId}/${data.uId}`);
  return res.data;
}

export const getAllWorkouts = async () => {
  const res = await axios.get(`${server}workouts/getAll`);
  return res.data;
}

///////////////////////////////////////////// SECURED //////////////////////////////////////////////////////////////////////////////////

export const GetAllWorkoutsSecured = async (data: { dateParam: string, statusParam: string }) => {
  try {
    const res = await axios.get(`${server}workouts/getAllSecured/${data.dateParam}/${data.statusParam}`);
    return res.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}

export const GetSingleWorkoutSecured = async (id: string) => {
  try {
    const res = await axios.get(`${server}workouts/getSingleSecured/${id}`);
    return res.data.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}

export const AddWorkout = async (workoutInfo: workoutDetailsInterface) => {
  try {
    const res = await axios.post(`${server}workouts/add`, workoutInfo);
    return res.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}

export const EditWorkout = async (workoutInfo: { id: string, workout: workoutDetailsInterface }) => {
  try {
    const res = await axios.patch(`${server}workouts/update/${workoutInfo.id}`, workoutInfo.workout);
    return res.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}

export const GetInstructorList = async () => {
  try {
    const res = await axios.get(`${server}instructors/get`);
    return res.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}

export const AddInstructor = async (instructor: { fullName: string, phoneNumber: string }) => {
  try {
    const res = await axios.post(`${server}instructors/add`, instructor);
    return res.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}

export const GetWorkoutsTypesList = async () => {
  try {
    const res = await axios.get(`${server}workoutsTypes/get`);
    return res.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}

export const AddWorkoutType = async (workoutType: { name: string }) => {
  try {
    const res = await axios.post(`${server}workoutsTypes/add`, workoutType);
    return res.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}

export const UpdateParticipantInfo = async (data: { workoutId: number, participantUniqueId: string, updatedData: participant }) => {
  try {
    const res = await axios.patch(`${server}workouts/updateParticipantInfo/${data.workoutId}/${data.participantUniqueId}`, data);
    return res.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}

export const RemoveInstructor = async (id: number) => {
  try {
    const res = await axios.delete(`${server}instructors/remove/${id}`);
    return res.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}

export const RemoveWorkoutType = async (id: number) => {
  try {
    const res = await axios.delete(`${server}workoutsTypes/remove/${id}`);
    return res.data;
  }
  catch (error: unknown) {
    return Promise.reject(error)
  }
}